module.exports = __webpack_public_path__ + "img/partner-onesia.c7c24001.png";